module.exports = __webpack_public_path__ + "static/media/money.3702a5f8.svg";